import { IonDatetime, IonDatetimeButton, IonModal } from '@ionic/react';
import classNames from 'classnames';
import { DateTime } from 'luxon';
import { useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { useGetUsersByDayQuery } from '../../api/UserApi';
import { DownloadCSVButton } from '../../components/DownloadCSVButton';
import { Header } from '../../components/Header';
import { IconButton } from '../../components/IconButton';
import { IconArrowBack } from '../../components/QuirkIcons';
import { QuirkIonContent } from '../../components/QuirkIonContent';
import { QuirkIonPage } from '../../components/QuirkIonPage';
import tableStyles from '../../styles/table.module.css';
import styles from './AdminUserLoginReport.module.css';
import { Checkbox } from '../../components/Forms/Checkbox';
export const AdminUserLoginReport = () => {
	const [startDate, setStartDate] = useState<string>(DateTime.now().minus({ days: 30 }).toISO());
	const [endDate, setEndDate] = useState<string>(DateTime.now().toISO());
	const [noAnon, setNoAnon] = useState<boolean>(true);
	const report = useGetUsersByDayQuery(
		{ startDate: startDate.substring(0, 10), endDate: endDate.substring(0, 10), noAnon },
		{ skip: !startDate || !endDate }
	);
	const history = useHistory();
	const tableRef = useRef<HTMLTableElement>(null);
	return (
		<QuirkIonPage name="User Login Report">
			<Header
				title="User Login Report"
				left={
					<IconButton
						icon={<IconArrowBack />}
						onClick={() => {
							history.go(-1);
						}}
					/>
				}
			/>
			<QuirkIonContent scroll={true}>
				<>
					<div className={styles.dateContainer}>
						<IonDatetimeButton style={{ width: 200 }} datetime="start" />
						<IonDatetimeButton style={{ width: 200 }} datetime="end" />
					</div>
					<IonModal keepContentsMounted>
						<IonDatetime
							presentation="date"
							id="start"
							value={startDate}
							onIonChange={e => {
								setStartDate(e.target.value as string);
							}}
						></IonDatetime>
					</IonModal>
					<IonModal keepContentsMounted>
						<IonDatetime
							presentation="date"
							id="end"
							value={endDate}
							onIonChange={e => {
								setEndDate(e.target.value as string);
							}}
						></IonDatetime>
					</IonModal>

					<div className={styles.reportTableContainer}>
						<Checkbox
							onClick={e => {
								setNoAnon(e.target.checked);
							}}
							value={noAnon}
							label="Remove Anonymous"
						/>
						<div className={styles.downloadButtonContainer}>
							<DownloadCSVButton
								style={{ width: 200 }}
								tableRef={tableRef}
								label="Download Report"
								filename="Unique Users By Day"
							/>
						</div>

						<table ref={tableRef} className={tableStyles.table}>
							<thead className={tableStyles.thead}>
								<tr className={tableStyles.trHead}>
									<th className={tableStyles.th}>Date</th>
									<th className={classNames(tableStyles.th, styles.center)}>Users</th>
								</tr>
							</thead>
							<div className={tableStyles.tbody}>
								{report.data?.map((item, index) => (
									<tr className={tableStyles.tr} key={index}>
										<td className={tableStyles.td}>{item.date}</td>
										<td className={classNames(tableStyles.td, styles.total, styles.center)}>
											{item.total}
										</td>
									</tr>
								))}
							</div>
						</table>
					</div>
				</>
			</QuirkIonContent>
		</QuirkIonPage>
	);
};
